import _extends from "@babel/runtime/helpers/esm/extends";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { TabPanel as ReakitTabPanel } from 'reakit';
import { useTabsContext } from './Tabs.Context';
import * as styles from './Tabs.styles';
var TabPanelView = styles.TabPanelView;

function TabPanel(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'TabPanel'),
      otherProps = _extends({}, _useContextSystem);

  var _useTabsContext = useTabsContext(),
      tab = _useTabsContext.tab;

  return /*#__PURE__*/React.createElement(ReakitTabPanel, Object.assign({
    as: TabPanelView,
    ref: forwardedRef
  }, tab, otherProps));
}

export default contextConnect(TabPanel, 'TabPanel');